import angular from 'angular';
import moment from 'moment';
import { getMimeTypeFromExtension } from '../../../../utils';
import axios from 'axios';
export class OblProcessoService {
    $q;
    $http;
    OblProcesso;
    OblProcessoAlteracaoestado;
    OblInteracao;
    OblInteracaoAgendamento;
    OblInteracaoOrcamentacao;
    OblInteracaoProduto;
    OblInteracaoExtras;
    OblEstado;
    OblCliente;
    OblValencia;
    FuncionarioEntidadeProprietaria;
    AuthenticationService;
    OblViatura;
    OblProduto;
    OblAnexo;
    OblLote;
    OblMotivo;
    OblAssocServico;
    constructor($q, $http, OblProcesso, OblProcessoAlteracaoestado, OblInteracao, OblInteracaoAgendamento, OblInteracaoOrcamentacao, OblInteracaoProduto, OblInteracaoExtras, OblEstado, OblCliente, OblValencia, FuncionarioEntidadeProprietaria, AuthenticationService, OblViatura, OblProduto, OblAnexo, OblLote, OblMotivo, OblAssocServico) {
        this.$q = $q;
        this.$http = $http;
        this.OblProcesso = OblProcesso;
        this.OblProcessoAlteracaoestado = OblProcessoAlteracaoestado;
        this.OblInteracao = OblInteracao;
        this.OblInteracaoAgendamento = OblInteracaoAgendamento;
        this.OblInteracaoOrcamentacao = OblInteracaoOrcamentacao;
        this.OblInteracaoProduto = OblInteracaoProduto;
        this.OblInteracaoExtras = OblInteracaoExtras;
        this.OblEstado = OblEstado;
        this.OblCliente = OblCliente;
        this.OblValencia = OblValencia;
        this.FuncionarioEntidadeProprietaria = FuncionarioEntidadeProprietaria;
        this.AuthenticationService = AuthenticationService;
        this.OblViatura = OblViatura;
        this.OblProduto = OblProduto;
        this.OblAnexo = OblAnexo;
        this.OblLote = OblLote;
        this.OblMotivo = OblMotivo;
        this.OblAssocServico = OblAssocServico;
    }
    criaLinhaImport(data) {
        return this.OblProcesso.import({ data }).$promise;
    }
    getParceiros() {
        return this.OblCliente.find({ filter: { where: { active: 1, parceiro: 1 } } }).$promise;
    }
    createProcesso(data) {
        let defer = this.$q.defer();
        this.OblProcesso.create({
            id: 0,
            active: 1,
            origem: 2,
            data: moment().format(),
            loteId: data.loteId,
            estadoId: 14,
            observacoes: data.observacoes,
            clienteId: data.clienteId,
            parceiro: data.parceiro,
            valenciaId: data.valenciaId,
            // Detalhes
            morada: data.morada,
            cep: data.cep,
            localidade: data.localidade,
            concelho: data.concelho,
            distrito: data.distrito,
            // Cliente
            nomeCliente: data.nomeCliente,
            nifCliente: data.nifCliente,
            tlmCliente: data.tlmCliente,
            emailCliente: data.emailCliente,
            // Fatura
            faturaNome: data.nomeCliente,
            faturaNif: data.nifCliente,
            faturaContacto: data.tlmCliente,
            faturaEmail: data.emailCliente,
            faturaMorada: data.morada,
            faturaCep: data.cep,
            faturaLocalidade: data.localidade,
            faturaConcelho: data.concelho,
            faturaDistrito: data.distrito
        })
            .$promise.then(r => {
            // Cria interacao
            this.createInteracao(r.id, data.tipoId, 14, true, data.agendamento.format(), data.tecnicoId)
                .then(_ => {
                defer.resolve(r);
            })
                .catch(e => {
                defer.reject(e);
            });
        })
            .catch(e => defer.reject(e));
        return defer.promise;
    }
    downloader(from, to) {
        return this.OblProcesso.downloader({ from, to }).$promise;
    }
    procuraProdutoStock(term) {
        return this.OblProduto.lookup({ term }).$promise;
    }
    getMotivos() {
        return this.OblMotivo.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise;
    }
    getViaturas() {
        return this.OblViatura.find({
            filter: {
                where: {
                    active: 1
                },
                include: {
                    relation: 'Stock',
                    scope: {
                        where: {
                            active: 1,
                            quantidade: {
                                gte: 1
                            }
                        },
                        include: 'Produto'
                    }
                }
            }
        }).$promise;
    }
    getClientes() {
        return this.OblCliente.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise;
    }
    getLotes() {
        return this.OblLote.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise;
    }
    getValencias() {
        return this.OblValencia.find({
            filter: {
                where: {
                    active: 1
                },
                include: 'categoria'
            }
        }).$promise;
    }
    createFicheiro(id, interacao, ficheiro, extra) {
        return this.OblAnexo.create({
            id: 0,
            processoId: id,
            interacaoId: interacao,
            nome: ficheiro,
            tipodocumentoId: 1,
            extra: extra,
            active: 1
        }).$promise;
    }
    createInteracao(id, tipo, estado, agendamento, data, tecnico) {
        let defer = this.$q.defer();
        this.OblInteracao.create({
            id: 0,
            processoId: id,
            tipoId: tipo,
            aceite: 0,
            data: moment().format(),
            criadoPor: this.AuthenticationService.getId(),
            active: 1
        })
            .$promise.then(r => {
            if (agendamento) {
                this.OblInteracaoAgendamento.create({
                    id: 0,
                    interacaoId: r.id,
                    data: moment(data).format('YYYY-MM-DD'),
                    hora: moment(data).format('HH:mm:00'),
                    agendadoa: moment().format(),
                    agendadoporId: this.AuthenticationService.getId(),
                    duracao: 60,
                    tecnicoId: tecnico,
                    active: 1
                })
                    .$promise.then(_ => {
                    this.alteraEstado(id, estado, tipo == 2 ? 4 : 9)
                        .then(z => {
                        defer.resolve(z);
                    })
                        .catch(e => {
                        defer.reject(e);
                    });
                })
                    .catch(e => {
                    defer.reject(e);
                });
            }
            else {
                this.alteraEstado(id, estado, tipo == 2 ? 2 : 7)
                    .then(_ => {
                    defer.resolve(r);
                })
                    .catch(e => {
                    defer.reject(e);
                });
            }
        })
            .catch(e => {
            defer.reject(e);
        });
        return defer.promise;
    }
    patchAgendamento(id, data, tecnicoId) {
        return this.OblInteracaoAgendamento.patch({ id: id }, {
            data: moment(data).format('YYYY-MM-DD'),
            hora: moment(data).format('HH:mm:00'),
            tecnicoId: tecnicoId
        }).$promise;
    }
    table(query) {
        return this.OblProcesso.table(query).$promise;
    }
    options() {
        return this.OblProcesso.options().$promise;
    }
    export(query) {
        return this.OblProcesso.export(query).$promise;
    }
    alteraEstado(id, atual, estado, observacoes) {
        return this.OblProcessoAlteracaoestado.create({
            id: 0,
            processoId: id,
            funcionarioId: this.AuthenticationService.getId(),
            dataAlteracao: moment().format(),
            estadoInicial: atual,
            estadoFinal: estado,
            observacoes: observacoes,
            active: 1
        }).$promise;
    }
    faturaCusto(id, observacoes) {
        return this.OblInteracaoExtras.createLinhaFatura({ id, observacoes }).$promise;
    }
    createLinhaArtigo(interacaoId, viaturaId, produtoId, quantidadeEfetiva, quantidadeFaturada, pvp) {
        return this.OblInteracaoProduto.create({
            id: 0,
            active: 1,
            interacaoId: interacaoId,
            tecnicoId: this.AuthenticationService.getId(),
            produtoId: produtoId,
            viaturaId: viaturaId,
            quantidadeFaturada: quantidadeFaturada,
            quantidadeEfetiva: quantidadeEfetiva,
            data: moment().format(),
            oferta: 0,
            pvp: pvp
        }).$promise;
    }
    createLinhaOrcamento(interacaoId, data) {
        data.dataRequisicao = moment().format();
        data.requisitanteId = this.AuthenticationService.getId();
        if (data.compra) {
            data.dataEncomenda = moment().format();
            data.encomendadoId = this.AuthenticationService.getId();
        }
        return this.OblInteracaoOrcamentacao.create({
            id: 0,
            active: 1,
            interacaoId: interacaoId,
            ...data
        }).$promise;
    }
    createLinhaCusto(interacaoId, data) {
        data.dataRequisicao = moment().format();
        data.requisitanteId = this.AuthenticationService.getId();
        /*
        if (data.encomendado) {
          data.dataEncomenda = moment().format();
          data.encomendadoId = this.AuthenticationService.getId();
        }
          */
        return this.OblInteracaoExtras.create({
            id: 0,
            active: 1,
            interacaoId: interacaoId,
            ...data
        }).$promise;
    }
    editLinhaOrcamento(id, data) {
        return this.OblInteracaoOrcamentacao.patch({
            id: id
        }, data).$promise;
    }
    encomendaLinhaOrcamento(id, data) {
        data.encomendado = 1;
        data.encomendadoId = this.AuthenticationService.getId();
        data.dataEncomenda = moment().format();
        if (data.active == 1 && data.compra) {
            data.dataEncomenda = moment().format();
            data.encomendadoId = this.AuthenticationService.getId();
        }
        return this.OblInteracaoOrcamentacao.patch({
            id: id
        }, data).$promise;
    }
    patchProcesso(id, data) {
        return this.OblProcesso.patch({
            id: id
        }, data).$promise;
    }
    rejeitaOrcamento(id, processo, estado) {
        let defer = this.$q.defer();
        this.OblInteracao.patch({ id }, {
            aceite: 0
        })
            .$promise.then(r => {
            this.alteraEstado(processo, estado, 11, 'Orçamento não aceite pelo cliente')
                .then((processo) => {
                defer.resolve();
            })
                .catch(e => defer.reject(e));
        })
            .catch(e => defer.reject(e));
        return defer.promise;
    }
    aceitaOrcamento(id, processo, estado) {
        let defer = this.$q.defer();
        this.OblInteracao.patch({ id }, {
            aceite: 1
        })
            .$promise.then(r => {
            this.alteraEstado(processo, estado, 7, 'Orçamento aceite pelo cliente')
                .then((processo) => {
                defer.resolve();
            })
                .catch(e => defer.reject(e));
        })
            .catch(e => defer.reject(e));
        return defer.promise;
    }
    fechaOrcamento(id, processo, estado) {
        let defer = this.$q.defer();
        this.OblInteracao.patch({ id }, {
            validado: 1,
            aceite: 2
        })
            .$promise.then(r => {
            this.alteraEstado(processo, estado, 6, 'Fecho de orçamento pendente')
                .then((processo) => {
                defer.resolve();
            })
                .catch(e => defer.reject(e));
        })
            .catch(e => defer.reject(e));
        return defer.promise;
    }
    fechaVisitaTecnica(id, processo, estado) {
        let defer = this.$q.defer();
        this.OblInteracao.patch({ id }, {
            validado: 1,
            aceite: 2
        })
            .$promise.then(r => {
            this.alteraEstado(processo, estado, 6, 'Fecho de orçamento pendente')
                .then((processo) => {
                defer.resolve();
            })
                .catch(e => defer.reject(e));
        })
            .catch(e => defer.reject(e));
        return defer.promise;
    }
    patchInteracao(id, data) {
        return this.OblInteracao.patch({ id }, data).$promise;
    }
    cancelaLinhaOrcamento(id, justificacao) {
        return this.OblInteracaoOrcamentacao.patch({
            id: id
        }, {
            cancelado: 1,
            justificacao: justificacao,
            dataCancelado: moment().format(),
            canceladoId: this.AuthenticationService.getId()
        }).$promise;
    }
    rececionaLinhaOrcamento(id, primavera) {
        return this.OblInteracaoOrcamentacao.patch({
            id: id
        }, {
            rececionado: 1,
            dataRececao: moment().format(),
            rececionadoId: this.AuthenticationService.getId()
        }).$promise;
    }
    getEstados() {
        return this.OblEstado.find({
            filter: {
                where: {
                    active: true
                }
            }
        }).$promise;
    }
    findTecnicos() {
        const defer = this.$q.defer();
        this.FuncionarioEntidadeProprietaria.find({
            filter: {
                where: {
                    entidadeProprietariaId: 3,
                    active: true
                },
                include: {
                    relation: 'funcionario'
                }
            }
        })
            .$promise.then(f => {
            const users = [];
            f.forEach(r => {
                if (r.funcionario) {
                    users.push(r.funcionario);
                }
            });
            defer.resolve(users.sort((a, b) => a.name.localeCompare(b.name)));
        })
            .catch(e => {
            defer.reject(e);
        });
        return defer.promise;
    }
    details(id) {
        return this.OblProcesso.findOne({
            filter: {
                where: {
                    id
                },
                include: [
                    'Lote',
                    {
                        relation: 'Faturacao',
                        scope: {
                            include: ['faturadopor', 'funcionario']
                        }
                    },
                    'Cliente',
                    {
                        relation: 'Valencia',
                        scope: {
                            include: 'categoria'
                        }
                    },
                    {
                        relation: 'Historico',
                        scope: {
                            include: ['Funcionario', 'EstadoFinal']
                        }
                    },
                    {
                        relation: 'Anexos',
                        scope: {
                            where: {
                                active: 1
                            }
                        }
                    },
                    {
                        relation: 'Interacaos',
                        scope: {
                            include: [
                                {
                                    relation: 'Fotografias',
                                    scope: {
                                        where: { active: true }
                                    }
                                },
                                {
                                    relation: 'InteracaoProdutos',
                                    scope: {
                                        where: {
                                            active: 1
                                        },
                                        include: 'Produto'
                                    }
                                },
                                {
                                    relation: 'Orcamentacao',
                                    scope: {
                                        where: {
                                            active: 1
                                        },
                                        include: ['Requisitante', 'RececionadoPor', 'EncomendadoPor', 'CanceladoPor']
                                    }
                                },
                                {
                                    relation: 'Extras',
                                    scope: {
                                        where: {
                                            active: 1
                                        }
                                    }
                                },
                                'InteracaoTipo',
                                'Motivo',
                                {
                                    relation: 'Agendamento',
                                    scope: {
                                        include: ['Funcionario', 'AgendadoPor']
                                    }
                                }
                            ]
                        }
                    },
                    'Anexos'
                ]
            }
        }).$promise;
    }
    pastaUpload() {
        let defer = this.$q.defer();
        defer.resolve('obler');
        return defer.promise;
    }
    detalhesFicheiro(main, folder, path) {
        return this.$http.get(`/api/${main}/${folder}/files/${path}`);
    }
    mimeTypeFicheiro(path) {
        return getMimeTypeFromExtension(path);
    }
    uploadFicheiro(main, folder, file) {
        const formData = new FormData();
        formData.append('file', file);
        return this.$http.post(`/api/${main}/${folder}/upload`, formData, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    }
    getInfoCodigoPostal(cp4, cp3) {
        return new Promise((resolve, reject) => {
            if (cp4.length === 4) {
                if (cp3.length === 3) {
                    axios
                        .post('/api/public/getLocalidade', {
                        cp4: cp4,
                        cp3: cp3
                    })
                        .then(r => {
                        resolve(r.data);
                    })
                        .catch(e => {
                        reject(e);
                    });
                }
                else {
                    axios
                        .post('/api/public/getLocalidade', {
                        cp4: cp4,
                        cp3: null
                    })
                        .then(r => {
                        resolve(r.data);
                    })
                        .catch(e => {
                        reject(e);
                    });
                }
            }
        });
    }
    getTipoTarefa() {
        return this.OblAssocServico.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise;
    }
}
OblProcessoService.$inject = [
    '$q',
    '$http',
    'OblProcesso',
    'OblProcessoAlteracaoestado',
    'OblInteracao',
    'OblInteracaoAgendamento',
    'OblInteracaoOrcamentacao',
    'OblInteracaoProduto',
    'OblInteracaoExtras',
    'OblEstado',
    'OblCliente',
    'OblValencia',
    'FuncionarioEntidadeProprietaria',
    'AuthenticationService',
    'OblViatura',
    'OblProduto',
    'OblAnexo',
    'OblLote',
    'OblMotivo',
    'OblAssocServico'
];
